import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthService from 'src/services/auth.service';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, CircularProgress } from '@mui/material';
import { useAppDispatch } from 'src/store';
import { masqueradeAsUser } from 'src/features/dashboard/dashboard.slice';
import { useSnackbar } from 'notistack';

const Masquerade = ({ open, onClose, userId, userName }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const handleMasquerade = async () => {
    setLoading(true);
    try {
      const response = await dispatch(masqueradeAsUser(userId)).unwrap();
      if (response.success) {
        enqueueSnackbar(`Successfully masqueraded as ${userName}`, {
          variant: 'success',
          autoHideDuration: 3000,
        });
      }
      onClose();
    } catch (error) {
      console.error("Masquerade failed:", error);
      enqueueSnackbar("Failed to masquerade as user. Please try again.", {
        variant: 'error',
        autoHideDuration: 3000,
      });
      setLoading(false);
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirm Masquerade</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to masquerade as {userName}?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" disabled={loading}>
          Cancel
        </Button>
        <Button onClick={handleMasquerade} color="primary" disabled={loading}>
          {loading ? <CircularProgress size={24} /> : 'Confirm'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Masquerade; 
